import { Observable } from 'rxjs';
import Raven from 'raven-js';

import { env_production } from 'core/constants';
import * as generalActions from 'modules/general/action';
import * as usersActions from 'modules/user/action';

const codes_validation = {
  presence: 'es requerido',
  uniqueness: 'ya existe',
};

export const request = (error, action, delay = 3000) => {
  if (!env_production) descriveError(error);

  return switchStatus(error, action, delay);
};

function descriveError(error) {
  console.log('error catch', error);
  if (error && error.response && error.response.error && error.response.error.message) console.log(error.response.error.message);
}

function switchStatus(error, action, delay) {
  switch (error.status) {
    case 0: {
      //if (action.epic.method === 'GET')
      return Observable.of(action).startWith(generalActions.snackbar_show('No hay conexion')).delay(delay);
      //else return Observable.of(generalActions.snackbar_show('No hay conexion'));
    }
    case 401:
      return Observable.merge(Observable.of(usersActions.logout()), Observable.of(generalActions.snackbar_show('No tiene permisos para esta funcion.')));
    case 404:
      return Observable.of(generalActions.snackbar_show('Error - No encontrado'));
    case 422:
      return validationErrors(error);
    case 457:
      return endpointError(error);
    case 500:
      Raven.captureMessage('Error 500', {
        extra: { error, action },
      });
      console.log('\nerror', error);

      return Observable.merge(Observable.of(generalActions.snackbar_show('Error en el servidor')), Observable.of(usersActions.logout()));
    case 502:
      return Observable.of(generalActions.snackbar_show('No hay conexion con el servidor'));
    default:
      Raven.captureMessage('Error sin definir', {
        extra: { error, action },
      });
      return Observable.of(generalActions.snackbar_show('Error - Code 1000'));
  }
}

function endpointError(error) {
  if (error.response && error.response.error && error.response.error.message) return Observable.of(generalActions.snackbar_show(error.response.error.message));
  else return Observable.of(generalActions.snackbar_show('Error - Code 0001'));
}

function validationErrors(error) {
  if (error.response.error.details && error.response.error.details.messages) {
    let codes = error.response.error.details.codes;
    let messages = error.response.error.details.messages;
    let array_result = [];
    let delay = 0;

    for (var cod in codes) {
      let errorMessage = messages[cod] ? messages[cod][0] : 'Error desconocido';
      array_result.push(Observable.timer(delay).mapTo(generalActions.snackbar_show('Error en ' + cod + ': ' + errorMessage)));
      delay = delay + 1000;
    }
    return Observable.merge(...array_result);
  } else {
    return Observable.of(generalActions.snackbar_show('Error en los datos del formulario'));
  }
}



// WEBPACK FOOTER //
// src/modules/error/action.js